import {Panes, TextField} from '@management-ui/core';
import {InputAdornment} from '@mui/material';
import React from 'react';

const Fields = ({cost = {}, prefix = '', children}) => (
  <Panes
    entity={cost}
    prefix={prefix}
    panes={[
      {
        title: 'Details',
        fields: [
          <TextField
            name="amount"
            prefix={prefix}
            label="Amount"
            rules={{required: 'Please enter an amount'}}
            fieldProps={{
              InputProps: {
                startAdornment: <InputAdornment position="start">£</InputAdornment>
              }
            }}
          />,
          <TextField
            name="notes"
            prefix={prefix}
            label="Notes"
            fieldProps={{multiline: true, rows: 3}}
          />
        ]
      }
    ]}
    title={null}
  >{children}</Panes>
);

export default Fields
